import axios from 'axios'

// Base configuration based on environment
const baseURL = import.meta.env.PROD ? window.location.origin + '/be/' : 'http://localhost:8000/be/'

const apiConfig = {
  baseURL,
  headers: {
    // 'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  timeout: 15000,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  retry: 3,
  retryDelay: 1000
}

const createApiClient = (config = apiConfig) => {
  const api = axios.create(config)

  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token')
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
      import.meta.env.DEV
      return config
    },
    (error) => Promise.reject(error)
  )

  api.interceptors.response.use(
    (response) => {
      import.meta.env.DEV
      return response
    },
    async (error) => {
      const originalRequest = error.config

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        // Add your refresh token logic here if needed
      }

      const errorMessage =
        error.response?.data?.message || error.message || 'An unexpected error occurred.'
      console.error('API Error:', errorMessage)
      return Promise.reject(error)
    }
  )

  return api
}

const api = createApiClient()

export default api
export { baseURL }
